module.exports = __webpack_public_path__ + "img/search-normal.4f09cb26.svg";